"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CareTeamImage = void 0;
var _react = _interopRequireDefault(require("react"));
var _careTeamUnit = _interopRequireDefault(require("../../images/care-team-unit.png"));
var _Avatar = require("../Avatar");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CareTeamImage = function CareTeamImage(props) {
  return /*#__PURE__*/_react.default.createElement(_Avatar.Avatar, _extends({}, props, {
    shape: "square"
    // Avatar uses name to create AvatarFallback
    // Provide fake name for care team
    ,
    name: "Care Coordinators",
    src: _careTeamUnit.default
  }));
};
exports.CareTeamImage = CareTeamImage;